const axios = require('axios');
// var $api = 'https://udolively.com/test/merchant/api/v1';
var $api = '';
const hostname = window.location.hostname;
if(hostname.includes('localhost')) {
  $api = '/server/test/merchant/api/v1';
} else {
  $api = 'https://udolively.com/test/merchant/api/v1';
}
import router from '../router/index';

export default function main($message, callback) {
  const data = JSON.parse(localStorage.getItem('logdata'));
  axios.post($api + '/users/username/login/', data).then(res => {
    if(res.data.code == 200) {
      const user = res.data.data;
      const header = {
        Identification: user.token,
      }
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('header', JSON.stringify(header));
      if(typeof callback == 'function') callback();
    } else {
      $message.error('登录过期，请重新登陆');
      router.replace('/backend/login');
    }
  })
}